// Contact Form Handling

(function() {
    'use strict';

    function initContactForm() {
        const form = document.getElementById('contactForm');
        const formStatus = document.getElementById('formStatus');

        if (!form) return;

        form.addEventListener('submit', async function(e) {
            e.preventDefault();

            // Get form data
            const company = document.getElementById('company').value;
            const service = document.getElementById('service').value;
            const baseMessage = document.getElementById('message').value;
            
            // Embed company and service info into the message
            let fullMessage = baseMessage;
            if (company) {
                fullMessage += `\n\nCompany: ${company}`;
            }
            if (service) {
                fullMessage += `\n\nService Interest: ${service}`;
            }

            const formData = {
                name: document.getElementById('name').value,
                email: document.getElementById('email').value,
                message: fullMessage
            };

            // Basic validation
            if (!baseMessage) {
                showFormStatus('Please fill in the message field.', 'error');
                return;
            }

            // Email validation
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(formData.email)) {
                showFormStatus('Please enter a valid email address.', 'error');
                return;
            }

            // Show loading state
            const submitButton = form.querySelector('.btn-submit');
            const originalButtonText = submitButton.textContent;
            submitButton.textContent = 'Sending...';
            submitButton.disabled = true;

            // Submit form data to API
            try {
                const response = await fetch('/api/contactus', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(formData)
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                // Show success message
                showFormStatus('Thank you for your message! I will get back to you soon.', 'success');

                // Reset form
                form.reset();

                // Reset button
                submitButton.textContent = originalButtonText;
                submitButton.disabled = false;

            } catch (error) {
                showFormStatus('Something went wrong. Please try again later.', 'error');
                submitButton.textContent = originalButtonText;
                submitButton.disabled = false;
            }
        });

        // Real-time validation
        const emailInput = document.getElementById('email');
        if (emailInput) {
            emailInput.addEventListener('blur', function() {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (this.value && !emailRegex.test(this.value)) {
                    this.style.borderColor = 'var(--color-error)';
                } else {
                    this.style.borderColor = '';
                }
            });

            emailInput.addEventListener('input', function() {
                this.style.borderColor = '';
            });
        }

        // Character counter for message field
        const messageField = document.getElementById('message');
        if (messageField) {
            messageField.addEventListener('input', function() {
                const length = this.value.length;
                if (length > 500) {
                    showFormStatus('Message is too long. Maximum 500 characters.', 'error');
                } else {
                    formStatus.textContent = '';
                    formStatus.className = 'form-status';
                }
            });
        }
    }

    function showFormStatus(message, type) {
        const formStatus = document.getElementById('formStatus');
        if (!formStatus) return;

        formStatus.textContent = message;
        formStatus.className = 'form-status ' + type;

        // Auto-hide after 5 seconds
        if (type === 'success') {
            setTimeout(() => {
                formStatus.textContent = '';
                formStatus.className = 'form-status';
            }, 5000);
        }
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initContactForm);
    } else {
        initContactForm();
    }

})();
